export var UserDevice;
(function (UserDevice) {
    UserDevice["Mobile"] = "mobile";
    UserDevice["Tablet"] = "tablet";
    UserDevice["Desktop"] = "desktop";
    UserDevice["WebViewIos"] = "webview.ios";
    UserDevice["WebViewAndroid"] = "webview.android";
    UserDevice["Unknown"] = "unknown";
})(UserDevice || (UserDevice = {}));
